<template>
    <v-container fluid class="pa-0">
      <v-card class="mx-auto empty-state-card" elevation="0">
        <div class="text-center pa-8">
          <!-- Icon -->
          <v-icon
            :color="iconColor"
            size="64"
            class="mb-4"
          >
            {{ icon }}
          </v-icon>
  
          <!-- Title -->
          <h2 class="text-h4 font-weight-bold mb-4">
            {{ title }}
          </h2>
  
          <!-- Description -->
          <p class="text-subtitle-1 grey--text mb-4">
            {{ description }}
          </p>
  
          <!-- Course Title if provided -->
          <p v-if="courseTitle" class="text-subtitle-1 font-weight-medium mb-6">
            Course: {{ courseTitle }}
          </p>
  
          <!-- Action Button for Admin -->
          <v-btn
            v-if="showActionButton && isAdmin"
            color="primary"
            class="mt-4"
            @click="$emit('action-clicked')"
          >
            <v-icon left>{{ actionIcon }}</v-icon>
            {{ actionText }}
          </v-btn>
        </div>
      </v-card>
    </v-container>
  </template>
  
  <script>
  export default {
    name: 'EmptyState',
    
    props: {
      type: {
        type: String,
        default: 'content',
        validator: value => ['content', 'error', 'no-access'].includes(value)
      },
      courseTitle: {
        type: String,
        default: ''
      },
      isAdmin: {
        type: Boolean,
        default: false
      }
    },
  
    computed: {
      stateConfig() {
        const configs = {
          content: {
            icon: 'mdi-book-open-variant',
            iconColor: 'amber darken-2',
            title: 'No Content Available',
            description: "This course doesn't have any content yet. Please check back later or contact your administrator.",
            actionText: 'Add Module Content',
            actionIcon: 'mdi-plus',
            showActionButton: true
          },
          error: {
            icon: 'mdi-alert-circle',
            iconColor: 'error',
            title: 'Unable to Load Course',
            description: 'There was an error loading the course content. Please try refreshing the page.',
            actionText: 'Refresh Page',
            actionIcon: 'mdi-refresh',
            showActionButton: true
          },
          'no-access': {
            icon: 'mdi-lock',
            iconColor: 'grey darken-1',
            title: 'Access Restricted',
            description: 'You do not have permission to view this course content.',
            showActionButton: false
          }
        };
  
        return configs[this.type] || configs.content;
      },
  
      icon() {
        return this.stateConfig.icon;
      },
  
      iconColor() {
        return this.stateConfig.iconColor;
      },
  
      title() {
        return this.stateConfig.title;
      },
  
      description() {
        return this.stateConfig.description;
      },
  
      actionText() {
        return this.stateConfig.actionText;
      },
  
      actionIcon() {
        return this.stateConfig.actionIcon;
      },
  
      showActionButton() {
        return this.stateConfig.showActionButton;
      }
    },
  
    methods: {
      handleAction() {
        if (this.type === 'error') {
          window.location.reload();
        } else {
          this.$emit('action-clicked');
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .empty-state-card {
    background-color: transparent !important;
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  </style>